'use client';

import React from 'react';
import { Zap, Building2, TrendingUp } from 'lucide-react';
import { useCountry } from '@/context/CountryContext';
import { useLanguage } from '@/context/LanguageContext';

export default function ConnectionsKpiRow() {
  const { profile, connections } = useCountry();
  const { t, fmtNum } = useLanguage();

  const finalCumulative = connections?.[connections?.length - 1]?.cumulative ?? profile?.baseCumulative;
  const prevMonthNew = connections?.[connections?.length - 2]?.newConnections ?? 0;
  const currentMonthNew = connections?.[connections?.length - 1]?.newConnections ?? profile?.newThisMonth;
  const pctChange = prevMonthNew > 0
    ? (((currentMonthNew - prevMonthNew) / prevMonthNew) * 100)?.toFixed(1)
    : '0.0';

  const kpis = [
    {
      id: 'ckpi-001',
      label: t('kpi.trackedConnections'),
      value: fmtNum(finalCumulative),
      delta: `${fmtNum(currentMonthNew)} ${t('kpi.deltaThisMonth')}`,
      deltaPositive: true,
      icon: Zap,
      iconColor: '#C9973A',
    },
    {
      id: 'ckpi-002',
      label: 'Active Program Utilities',
      value: '5',
      delta: 'CIE, SENELEC, CEET, SBEE, ECG/NEDCO',
      deltaPositive: true,
      icon: Building2,
      iconColor: '#4A9EB5',
    },
    {
      id: 'ckpi-003',
      label: t('table.newThisMonth'),
      value: fmtNum(currentMonthNew),
      delta: `${pctChange}% vs prior month (${fmtNum(prevMonthNew)})`,
      deltaPositive: currentMonthNew >= prevMonthNew,
      icon: TrendingUp,
      iconColor: '#22A06B',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {kpis?.map((kpi) => {
        const IconComp = kpi?.icon;
        return (
          <div
            key={kpi?.id}
            className="bg-surface-card rounded-xl p-5 border border-surface-border shadow-card hover:shadow-card-md transition-shadow"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1 min-w-0">
                <p
                  className="text-xs font-medium uppercase tracking-wide mb-3 text-text-muted"
                  style={{ letterSpacing: '0.06em' }}
                >
                  {kpi?.label}
                </p>
                <p
                  className="text-3xl font-bold tabular-nums tracking-tight text-text-main"
                  style={{ fontVariantNumeric: 'tabular-nums' }}
                >
                  {kpi?.value}
                </p>
                <p
                  className={`text-xs mt-2 font-medium ${
                    kpi?.deltaPositive ? 'text-status-green' : 'text-status-red'
                  }`}
                >
                  {kpi?.deltaPositive ? '↑ ' : '↓ '}
                  {kpi?.delta}
                </p>
              </div>
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ml-3"
                style={{ backgroundColor: `${kpi?.iconColor}18` }}
              >
                <IconComp size={20} style={{ color: kpi?.iconColor }} strokeWidth={1.8} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}